import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useWhitelabel } from 'contexts/WhitelabelThemeContext';
const LOGO_SRC_PATH = '/img/logo/'

const Logo = (props) => {
    const { type, mode, gutter, className, imgClass, style, logoWidth } = props
    const { whitelabel } = useWhitelabel();

    return (
        <div
            className={classNames('logo', className, gutter)}
            style={{
                ...style,
                ...{ width: logoWidth },
            }}
        >
            <img
                className={imgClass}
                src={
                    type == 'full-studio'
                        ? (whitelabel.logoStudio ?? whitelabel.logoRectangular)
                        : type == 'full'
                        ? whitelabel.logoRectangular
                        : whitelabel.logo
                }
                alt={`${whitelabel?.name} logo`}
            />
        </div>
    )
}

Logo.defaultProps = {
    mode: 'light',
    type: 'full',
    logoWidth: 'auto',
}

Logo.propTypes = {
    mode: PropTypes.oneOf(['light', 'dark']),
    type: PropTypes.oneOf(['full', 'streamline', 'full-studio']),
    gutter: PropTypes.string,
    imgClass: PropTypes.string,
    logoWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Logo
